import { render, staticRenderFns } from "./SysNcConfigManager.vue?vue&type=template&id=2fcd29ee&"
import script from "./SysNcConfigManager.vue?vue&type=script&lang=js&"
export * from "./SysNcConfigManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports